import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { PageLayout } from '@/shared/layout/PageLayout';
import { useUserDetail } from './hooks/useUserDetail';
import { UserDetailHeader } from './components/UserDetailHeader';
import { UserDetailTabs } from './components/UserDetailTabs';
import { GeneralInfoTab } from './components/GeneralInfoTab';
import { SalaryInfoTab } from './components/SalaryInfoTab';
import { WorkStatusCard } from './components/WorkStatusCard';
import { AccountInfoCard } from './components/AccountInfoCard';
import { EmergencyContactCard } from './components/EmergencyContactCard';

export function UserDetailPage() {
 const { id } = useParams();
 const { data: user, isLoading } = useUserDetail(id);
 const [activeTab, setActiveTab] = useState('general');

 return (
 <PageLayout
 title="Hồ sơ nhân sự"

 isLoading={isLoading}
 isEmpty={!user && !isLoading}
 emptyTitle="Không tìm thấy nhân sự"
 emptyDescription="Vui lòng kiểm tra lại đường dẫn hoặc quay lại danh sách."
 >
 {user && (
 <div className="space-y-6">
 {/* Main Header Info */}
 <UserDetailHeader user={user} />

 {/* Navigation Tabs */}
 <UserDetailTabs activeTab={activeTab} onTabChange={setActiveTab} />

 {/* Content Area */}
 <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">
 {/* Left Column: Tab Content */}
 <div className="xl:col-span-2">
 {activeTab === 'general' && <GeneralInfoTab user={user} />}
 {activeTab === 'salary' && <SalaryInfoTab user={user} />}
 
 {activeTab !== 'general' && activeTab !== 'salary' && (
 <div className="flex flex-col items-center justify-center py-20 bg-white rounded-md border border-dashed border-slate-100">
 <div className="w-12 h-12 bg-slate-50 rounded-full flex items-center justify-center mb-4 text-slate-300">
 <i className="ri-tools-line text-xl" />
 </div>
 <h3 className="sm:text-sm text-xs text-slate-800 mb-1">Đang phát triển</h3>
 <p className="sm:text-sm text-xs text-slate-400">Nội dung tab này đang được xây dựng.</p>
 </div>
 )}
 </div>

 {/* Right Column: Side Cards */}
 <div className="xl:col-span-1 space-y-6">
 <WorkStatusCard user={user} />
 <AccountInfoCard user={user} />
 <EmergencyContactCard user={user} />
 </div>
 </div>
 </div>
 )}
 </PageLayout>
 );
}

export default UserDetailPage;
